import type { PropsWithChildren } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import type { IManagementCardHeaderProps } from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/ManagementCardHeader";
import ManagementCardHeader from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/ManagementCardHeader";

import {
    StyledManagementCardBodySlot,
    StyledManagementCardFooterSlot,
    StyledManagementCardGridWrapper,
    StyledManagementCardHeaderSlot,
} from "./styles";

interface IProps extends IManagementCardHeaderProps {
    dataAutomation?: string;
    message: string;
}

const ManagementSmallCard = ({
    dataAutomation,
    message,
    children,

    ...headerProps
}: PropsWithChildren<IProps>) => {
    return (
        <StyledManagementCardGridWrapper data-automation={dataAutomation}>
            <StyledManagementCardHeaderSlot>
                <ManagementCardHeader {...headerProps} />
            </StyledManagementCardHeaderSlot>

            <StyledManagementCardBodySlot>
                <Text
                    data-automation="management-card-text"
                    fontVariant="body2"
                    color={colorsPalettes.carbon["300"]}
                >
                    {message}
                </Text>
            </StyledManagementCardBodySlot>

            {children ? <StyledManagementCardFooterSlot>{children}</StyledManagementCardFooterSlot> : null}
        </StyledManagementCardGridWrapper>
    );
};

export default ManagementSmallCard;
